import React, { useEffect, useRef } from "react"
import circle from "../../../../assets/images/icons/circle.svg"
import BankDetailIcon from "../../../../assets/images/icons/bank-details.svg"
import AdditionalDetailsIcon from "../../../../assets/images/icons/additional-details.svg"
import IDVerificationIcon from "../../../../assets/images/icons/id-verification.svg"
import Agreement from "../../../../assets/images/icons/agreement.svg"
import CheckedFill from "../../../../assets/images/icons/checked-filled.svg"
import AuthorityLetter from "../../../../assets/images/icons/authority-letter.svg"
import AuthorisedSignatoryIcon from "../../../../assets/images/icons/authorised-signatory-kyc.svg"
import { useDispatch } from "react-redux"
import { useState } from "react"
import { Spinner } from "reactstrap"
import { setkycSteps } from "store/slices/commonSlice"
import { useUpdateInvestorOnboardedStepMutation } from "store/api/wealthpartnerapi/onboard.api"

const getSteps = () => {
  return [
    {
      stepNo: 1,
      label: "Proof of Identity",
      key: ["PAN_GST", "GST_DETAILS", "GST_WAIVER"],
      type: "step",
      icon: IDVerificationIcon,
    },
    {
      icon: circle,
    },
    {
      stepNo: 2,
      label: "Additional Details",
      key: ["BUSINESS_ADDITIONAL_DETAILS"],
      type: "step",
      icon: AdditionalDetailsIcon,
    },
    {
      icon: circle,
    },
    {
      stepNo: 3,
      label: "Bank Verification",
      key: ["BANK_VERIFICATION", "BANK_DETAILS"],
      type: "step",
      icon: BankDetailIcon,
    },
    {
      icon: circle,
    },
    {
      stepNo: 4,
      label: "Authorised Person",
      key: ["AUTHORISED_SIGNATORY"],
      type: "step",
      icon: AuthorisedSignatoryIcon,
    },
    {
      icon: circle,
    },
    {
      stepNo: 5,
      label: "Upload <br/>Authority Letter",
      key: ["AUTHORITY_LETTER"],
      type: "step",
      icon: AuthorityLetter,
    },
    {
      icon: circle,
    },
    {
      stepNo: 6,
      label: "Agreement Details",
      key: ["AGREEMENT_DETAILS"],
      type: "step",
      icon: Agreement,
    },
    {
      key: ["FINAL_STEP"],
      type: "final",
    },
  ]
}

const OnboardProgressBar = ({ kycData }) => {
  const [steps, setSteps] = useState([])
  const [clickedStep, setClickedStep] = useState("")
  const [updateStep, { isLoading }] = useUpdateInvestorOnboardedStepMutation()
  const containerRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (kycData) {
      const initialSteps = getSteps()
      const currentStepKey = kycData.current_step

      const currentIndex = initialSteps.findIndex(
        (step) => step.key && step.key.includes(currentStepKey)
      )

      const updatedSteps = initialSteps.map((item, index) => {
        if (!item.key) {
          const prevStepIndex = index - 1
          return {
            ...item,
            icon:
              prevStepIndex >= 0 && prevStepIndex < currentIndex
                ? CheckedFill
                : circle,
          }
        }
        return item
      })

      setSteps(updatedSteps)
      dispatch(setkycSteps(updatedSteps.filter((item) => item.stepNo)))
    }
  }, [kycData])

  const canEditStep = (steps) => {
    return steps.some((item) => kycData?.completed_steps?.includes(item))
  }

  const goToStep = async (kyc_status) => {
    setClickedStep(kyc_status)
    let status = kyc_status
    if (kyc_status === "PAN_GST") {
      if (kycData?.companyDetails?.gst_waiver) status = "GST_WAIVER"
      if (!kycData?.companyDetails?.gst_waiver) status = "GST_DETAILS"
    }

    try {
      await updateStep({
        kyc_status: status,
        id: kycData?.investor_id,
      }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  useEffect(() => {
    const container = containerRef.current
    if (!container) return
    if (window.innerWidth < 768) {
      const target = container.querySelector(`.${kycData.current_step}`)

      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        })
      }
    }
  }, [kycData])

  return (
    <>
      <div className="progress-bar-wrapper-section" ref={containerRef}>
        <div className="progress-bar-wrapper">
          {steps.map((item, index) => (
            <React.Fragment key={`steps_${index}`}>
              {item.type !== "final" && (
                <>
                  {item.type === "step" ? (
                    <div
                      className={`progress-step-wrapper ${item.key.join(" ")} ${
                        canEditStep(item.key) &&
                        !item.key.includes(kycData.current_step)
                          ? "cp can-edit"
                          : ""
                      }`}
                      onClick={(e) =>
                        canEditStep(item.key) &&
                        !item.key.includes(kycData.current_step)
                          ? goToStep(item.key[0])
                          : e.preventDefault()
                      }
                    >
                      <div className="progress-step">
                        {isLoading && clickedStep === item.key[0] ? (
                          <Spinner size={"sm"} />
                        ) : (
                          <img src={item.icon} alt="" />
                        )}
                      </div>
                      <div className="step-section">
                        <p>Step {item.stepNo}</p>
                        <h5
                          dangerouslySetInnerHTML={{
                            __html: item.label,
                          }}
                        ></h5>
                      </div>
                    </div>
                  ) : (
                    <div className="progress">
                      <img src={item.icon} alt="" />
                    </div>
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  )
}

export default OnboardProgressBar
